import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { BannerSearchDto } from '../../../dto/bannersearch/bannersearchdto';

export interface BannerSearchRequest extends APIRequest
{
    getBannerSearchRequest(): BannerSearchDto;
}

export class BannerSearchRequestImpl extends APIRequestDtoImpl implements BannerSearchRequest
{
    constructor(private bannerSearchData: BannerSearchDto)
    {
        super();
    }

    getBannerSearchRequest(): BannerSearchDto
    {
        return this.bannerSearchData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/bannersearch/bannersearchrequest.tsx